import { render, staticRenderFns } from "./FooterLogo.vue?vue&type=template&id=39971bda&scoped=true"
import script from "./FooterLogo.vue?vue&type=script&lang=js"
export * from "./FooterLogo.vue?vue&type=script&lang=js"
import style0 from "./FooterLogo.vue?vue&type=style&index=0&id=39971bda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39971bda",
  null
  
)

export default component.exports